(() => {
  const ROOT = 'leavys-results';
  let controller;
  let requestId = 0;
  let updateTimer;
  const root = () => document.querySelector(ROOT);
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;
  const pageSize = url => [24,48,72].includes(Number(url.searchParams.get('per_page'))) ? Number(url.searchParams.get('per_page')) : 24;
  if (!root()) return;
  const viewKey = value => {
    const url = new URL(value, location.href);
    for (const key of ['preview_theme_id','section_id','_fd','pb']) url.searchParams.delete(key);
    url.searchParams.sort();
    return url.pathname + url.search;
  };
  let renderedLocation = viewKey(location.href);
  let loading = false;
  let restoring = false;
  let restoreVersion = 0;
  let restoreObserver;
  let restoreTimers = [];
  let saveTimer;
  const savedView = () => {
    const view = history.state?.leavysResults;
    return view?.url === viewKey(location.href) && Number.isFinite(view.y) ? view : null;
  };
  function saveView() {
    const el = root();
    if (!el || loading || restoring || renderedLocation !== viewKey(location.href)) return;
    const card = [...el.querySelectorAll('.nf-card')].find(node => {
      const rect = node.getBoundingClientRect();
      return rect.bottom > 100 && rect.top < innerHeight;
    });
    const view = {
      url: renderedLocation, x: scrollX, y: scrollY,
      anchor: card?.dataset.productId, top: card?.getBoundingClientRect().top,
      panel: Boolean(el.querySelector('[data-nf-panel]')?.open),
      facets: [...el.querySelectorAll('[data-facet][open]')].map(node => node.dataset.facet)
    };
    try { history.replaceState({...history.state, leavysResults:view}, ''); } catch (_) {}
  }
  function cancelRestore() {
    restoreVersion++;
    restoring = false;
    restoreObserver?.disconnect();
    restoreTimers.forEach(clearTimeout);
    restoreTimers = [];
  }
  function restoreView(view) {
    if (!view || !root()) return;
    cancelRestore();
    const version = restoreVersion;
    restoring = true;
    const el = root();
    const panel = el.querySelector('[data-nf-panel]');
    if (panel) panel.open = mobile() ? view.panel : true;
    el.querySelectorAll('[data-facet]').forEach(node => {node.open = view.facets?.includes(node.dataset.facet) || false;});
    layout();
    const position = () => {
      if (version !== restoreVersion || !restoring || loading) return;
      const card = [...root().querySelectorAll('.nf-card')].find(node => node.dataset.productId === view.anchor);
      const top = card && Number.isFinite(view.top) ? scrollY + card.getBoundingClientRect().top - view.top : view.y;
      window.scrollTo({left:view.x || 0, top:Math.max(0,top), behavior:'instant'});
    };
    position();
    if (typeof ResizeObserver !== 'undefined') {
      restoreObserver = new ResizeObserver(position);
      restoreObserver.observe(document.documentElement);
      restoreObserver.observe(el);
    }
    for (const delay of [0,100,350,900]) restoreTimers.push(setTimeout(position,delay));
    restoreTimers.push(setTimeout(() => {cancelRestore();saveView();},1500));
  }
  const initialView = savedView();
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  for (const type of ['wheel','touchstart','pointerdown','keydown']) window.addEventListener(type,cancelRestore,{passive:true});
  window.addEventListener('scroll', () => {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveView,120);
  }, {passive:true});
  window.addEventListener('pagehide',saveView);
  document.addEventListener('visibilitychange',() => {if (document.visibilityState === 'hidden') saveView();});
  document.addEventListener('click',e => {if (e.target.closest?.('a[href]') && !e.defaultPrevented) saveView();},true);
  window.addEventListener('pageshow',e => {
    if (!e.persisted) return;
    if (loading) navigate(location.href,{push:false,restore:savedView()});
    else restoreView(savedView());
  });
  function normalise(url) {
    let next = new URL(url, location.href);
    const currentPath = location.pathname;
    if (root()?.dataset.nfView && next.pathname === currentPath) next.searchParams.set('view', root().dataset.nfView);
    const searchPage = next.pathname.endsWith('/search');
    if (searchPage && next.searchParams.get('q') === new URL(location.href).searchParams.get('q')) {
      for (const key of ['ls','lsq','ls_style']) if (!next.searchParams.has(key) && new URL(location.href).searchParams.has(key)) next.searchParams.set(key,new URL(location.href).searchParams.get(key));
    }
    if (window.LeavysSearch) next = window.LeavysSearch.resolve(next);
    if (root()?.dataset.stockReady === 'true') next.searchParams.set('filter.v.availability', '1');
    if (root()?.dataset.nfPreview === 'true') next.searchParams.delete('preview_theme_id');
    const current = new URL(location.href);
    for (const key of ['_fd','pb']) if (current.searchParams.has(key) && !next.searchParams.has(key)) next.searchParams.set(key,current.searchParams.get(key));
    next.searchParams.delete('section_id');
    const size = pageSize(next);
    if (size === 24) next.searchParams.delete('per_page');
    else next.searchParams.set('per_page',size);
    if (size > 24) {
      const page = Math.max(1,parseInt(next.searchParams.get('page'),10) || 1);
      next.searchParams.set('page',Math.floor((page-1)/(size/24))*(size/24)+1);
    }
    return next;
  }
  function showResults(el) {
    if (mobile()) el.querySelector('[data-nf-panel]').open = false;
    layout();
    const count = el.querySelector('[data-nf-count]');
    count.tabIndex = -1;
    count.focus({preventScroll:true});
    count.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  }
  function layout() {
    const el = root();
    if (!el) return;
    const header = document.querySelector('#header');
    const position = header && getComputedStyle(header).position;
    const headerHeight = mobile() && ['fixed','sticky'].includes(position) ? header.getBoundingClientRect().height : 0;
    el.style.setProperty('--nf-header-offset', `${headerHeight}px`);
    const panel = el.querySelector('[data-nf-panel]');
    el.querySelectorAll('[data-nf-open]').forEach(button => button.setAttribute('aria-expanded', String(Boolean(panel?.open))));
  }
  function init(resetPanel = true) {
    const el = root();
    if (!el) return;
    const panel = el.querySelector('[data-nf-panel]');
    if (panel && resetPanel) panel.open = !mobile();
    el.classList.add('nf-enhanced');
    el.querySelectorAll('.nf-mobile-actions').forEach(actions => {actions.hidden = false;});
    const pageControl = el.querySelector('[data-nf-page-size]');
    if (pageControl) {
      pageControl.hidden = false;
      pageControl.querySelector('select').value = String(pageSize(new URL(location.href)));
    }
    layout();
  }
  function groupedPagination(el, url, size) {
    const total = Math.ceil(Number(el.dataset.nfResultCount)/size);
    const current = Math.floor((Number(url.searchParams.get('page') || 1)-1)/(size/24))+1;
    const nav = el.querySelector('.nf-pagination');
    if (!nav) return;
    nav.replaceChildren();
    nav.hidden = total <= 1;
    el.dataset.nfPage = String(current);
    const add = (label,page,rel) => {
      const node = document.createElement(page === current ? 'span' : 'a');
      node.textContent = label;
      if (page === current) node.setAttribute('aria-current','page');
      else {
        const target = new URL(url);
        target.searchParams.set('page',(page-1)*(size/24)+1);
        node.href = target.href;
        node.setAttribute('data-nf-link','');
        if (rel) node.rel = rel;
      }
      nav.append(node);
    };
    if (current > 1) add(nav.dataset.previous || 'Previous',current-1,'prev');
    let previous = 0;
    for (const page of [...new Set([1,current-1,current,current+1,total])].filter(p=>p>0&&p<=total).sort((a,b)=>a-b)) {
      if (previous && page-previous>1) {const gap=document.createElement('span');gap.textContent='…';nav.append(gap);}
      add(String(page),page);previous=page;
    }
    if (current < total) add(nav.dataset.next || 'Next',current+1,'next');
  }
  function track(name, detail = {}) {
    document.dispatchEvent(new CustomEvent('leavys:discovery', {detail:{name,...detail}}));
  }
  async function navigate(destination, {push = true, replace = false, focusResults = false, interaction, restore} = {}) {
    clearTimeout(updateTimer);
    cancelRestore();
    const restoreToken = restoreVersion;
    if (push) saveView();
    const el = root();
    if (!el) return;
    const url = normalise(destination);
    const fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', el.dataset.sectionId);
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const currentRequest = ++requestId;
    const openFacets = [...el.querySelectorAll('[data-facet][open]')].map(x => x.dataset.facet);
    const focused = document.activeElement;
    const focusName = focused?.name;
    const focusValue = focused?.value;
    loading = true;
    el.setAttribute('aria-busy', 'true');
    try {
      const load = async (target = fetchUrl) => {
        const response = await fetch(target, {signal, credentials:'same-origin'});
        if (!response.ok) throw new Error(`Filter response ${response.status}`);
        return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(ROOT);
      };
      let next = await load();
      if (currentRequest !== requestId) return;
      const previewTheme = el.dataset.nfPreview === 'true' && el.dataset.nfThemeId;
      if (previewTheme && next?.dataset.nfThemeId !== previewTheme) {
        const pin = new URL(location.pathname, location.origin);
        pin.searchParams.set('preview_theme_id', previewTheme);
        await fetch(pin, {signal, credentials:'same-origin'});
        next = await load();
        if (next?.dataset.nfThemeId !== previewTheme) throw new Error('Preview theme changed');
      }
      if (!next) throw new Error('Missing results');
      const size = pageSize(url);
      let ranked = false;
      if (window.LeavysSearchRanking?.enabled(url)) {
        try {
          ranked = await window.LeavysSearchRanking.apply(next,url,size,signal);
          if (ranked) groupedPagination(next,url,size);
        } catch (error) {
          if (error.name === 'AbortError') throw error;
          // Native results remain usable if the optional merchandising service fails.
        }
      }
      if (size > 24 && !ranked) {
        const firstPage = Number(url.searchParams.get('page') || 1);
        const totalPages = Math.ceil(Number(next.dataset.nfResultCount)/24);
        const additional = [];
        for (let page=firstPage+1;page<firstPage+size/24 && page<=totalPages;page++) {
          const extraUrl = new URL(fetchUrl); extraUrl.searchParams.set('page',page);
          additional.push(load(extraUrl));
        }
        const extraPages = await Promise.all(additional);
        for (const extra of extraPages) {
          if (!extra || extra.dataset.nfThemeId !== next.dataset.nfThemeId || extra.dataset.nfResultCount !== next.dataset.nfResultCount) throw new Error('Results changed while loading');
          // Extra pages belong below the first visible row of the combined grid.
          extra.querySelectorAll('.nf-card__image img').forEach(image => {
            image.setAttribute('loading', 'lazy');
            image.setAttribute('fetchpriority', 'auto');
          });
          next.querySelector('[data-nf-grid]').append(...extra.querySelector('[data-nf-grid]').children);
        }
        groupedPagination(next,url,size);
      }
      if (currentRequest !== requestId) return;
      next.querySelectorAll('[data-facet]').forEach(f => {f.open = openFacets.includes(f.dataset.facet) || f.querySelector('input:checked') !== null;});
      next.querySelector('[data-nf-panel]').open = mobile() ? el.querySelector('[data-nf-panel]').open && !focusResults : true;
      const searchForm = el.querySelector('[data-ls-form]');
      const searchFocus = (replace || push) && searchForm?.contains(document.activeElement) ? document.activeElement : null;
      const positionBefore = {left:scrollX,top:scrollY};
      const controlBefore = el.contains(document.activeElement) && document.activeElement.matches('input,select') ? document.activeElement : null;
      const controlTop = controlBefore?.getBoundingClientRect().top;
      if (searchFocus) next.querySelector('[data-ls-form]')?.replaceWith(searchForm);
      el.replaceWith(next);
      if (replace) history.replaceState({...history.state}, '', url);
      else if (push) history.pushState({}, '', url);
      renderedLocation = viewKey(url);
      loading = false;
      init(false);
      if (searchFocus) {
        searchFocus.focus({preventScroll:true});
      } else if (restore && restoreToken === restoreVersion) {
        restoreView(restore);
      } else if (focusResults) {
        showResults(next);
      } else if (focusName) {
        [...next.querySelectorAll('input,select')].find(x=>x.name===focusName && x.value===focusValue)?.focus({preventScroll:true});
      }
      document.dispatchEvent(new CustomEvent('leavys:filters-rendered', {detail:{count:next.querySelectorAll('[data-product-id]').length}}));
      if (push && !focusResults && !restore && !searchFocus) {
        const controlAfter = controlBefore && [...next.querySelectorAll('input,select')].find(node => node.name === controlBefore.name && node.value === controlBefore.value);
        const top = controlAfter ? scrollY + controlAfter.getBoundingClientRect().top - controlTop : positionBefore.top;
        window.scrollTo({left:positionBefore.left,top:Math.max(0,top),behavior:'instant'});
      }
      if (interaction) track(interaction.name, interaction);
      if (next.dataset.nfResultCount === '0') track('empty_results', {source:interaction?.name || 'navigation'});
      saveView();
    } catch(error) {
      if (error.name === 'AbortError' || currentRequest !== requestId) return;
      loading = false;
      el.removeAttribute('aria-busy');
      location.assign(url.href);
    }
  }
  function submit(form, focusResults, name = 'filter_apply') {
    const url = new URL(form.action, location.href);
    const current = new URL(location.href);
    for (const key of ['preview_theme_id','_fd','pb']) if(current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key));
    for (const [key,value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key,value);
    const next = normalise(url);
    next.searchParams.sort();
    const existing = normalise(location.href);
    existing.searchParams.sort();
    if (next.href === existing.href && root().getAttribute('aria-busy') !== 'true') {
      if (focusResults) showResults(root());
      return;
    }
    navigate(next,{focusResults,interaction:{name}});
  }
  document.addEventListener('submit', e => {
    if (!e.target.matches('[data-nf-form]')) return;
    e.preventDefault(); submit(e.target, mobile());
  });
  document.addEventListener('change', e => {
    const form = e.target.form;
    if (!form?.matches('[data-nf-form]')) return;
    if (['sort_by','per_page'].includes(e.target.name)) {
      submit(form, false, e.target.name === 'sort_by' ? 'sort_change' : 'page_size_change');
      return;
    }
    clearTimeout(updateTimer);
    controller?.abort();
    requestId++;
    root().setAttribute('aria-busy', 'true');
    updateTimer = setTimeout(() => submit(form, false), 200);
  });
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-nf-open]');
    if (button && button.closest(ROOT)) {
      const el = root();
      const panel = el.querySelector('[data-nf-panel]');
      const isSize = button.dataset.nfOpen === 'size';
      panel.open = isSize || !panel.open;
      layout();
      if (panel.open) {
        const facet = isSize ? el.querySelector('[data-facet="filter.v.option.size"]') : panel;
        if (facet) {
          facet.open = true;
          facet.querySelector('summary')?.focus({preventScroll:true});
          facet.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        }
        track('filter_open', {source:isSize ? 'size_button' : 'filter_button'});
      }
      return;
    }
    const link = e.target.closest('[data-nf-link]');
    if (!link || !link.closest(ROOT) || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    const url = new URL(link.href, location.href);
    const currentSize = pageSize(new URL(location.href));
    if (currentSize > 24) url.searchParams.set('per_page',currentSize);
    const shortcut = link.dataset.nfShortcut;
    if (shortcut && link.dataset.nfActive !== 'true') {
      url.searchParams.delete(link.dataset.nfExclusive);
      url.searchParams.set(link.dataset.nfExclusive, link.dataset.nfValue);
    }
    const isPage = link.closest('.nf-pagination') !== null;
    const name = shortcut ? 'shortcut_select' : isPage ? 'page_change' : 'filter_remove';
    navigate(url,{focusResults:isPage || Boolean(shortcut), interaction:{name,source:shortcut || name}});
  });
  document.addEventListener('toggle', e => {
    if (e.target.matches?.('[data-nf-panel]')) layout();
  }, true);
  window.addEventListener('popstate',() => {
    const view = savedView();
    if (!loading && renderedLocation === viewKey(location.href)) restoreView(view);
    else navigate(location.href,{push:false,restore:view});
  });
  const breakpoint = window.matchMedia('(max-width: 749px)');
  breakpoint.addEventListener('change',()=>init());
  window.addEventListener('resize',layout,{passive:true});
  if (typeof ResizeObserver !== 'undefined' && document.querySelector('#header')) new ResizeObserver(layout).observe(document.querySelector('#header'));
  init();
  const initial = normalise(location.href);
  if (pageSize(initial) > 24 || window.LeavysSearchRanking?.enabled(initial)) navigate(initial,{push:false,replace:true,restore:initialView});
  else if (initial.href !== location.href) {
    const current = new URL(location.href);
    current.searchParams.delete('preview_theme_id');
    if (initial.search !== current.search) navigate(initial,{push:false,replace:true,restore:initialView});
    else {
      history.replaceState({...history.state},'',initial);
      renderedLocation = viewKey(initial);
      if (initialView) restoreView(initialView); else saveView();
    }
  } else {
    if (initialView) restoreView(initialView); else saveView();
  }
})();
